import * as React from 'react'
import { IconButton, Link, Popover, Stack, Switch, Typography } from '@mui/material'
import CallTwoToneIcon from '@mui/icons-material/CallTwoTone'
import MailIcon from '@mui/icons-material/Mail'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import { darkTheme, theme } from '../theme.js'
import PropTypes from 'prop-types'

export function HeaderIcons({ currentTheme, setCurrentTheme }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [anchorText, setAnchorText] = React.useState(null)
  const onContactIconClick = (event, text) => {
    setAnchorText(text)
    setAnchorEl(event.target)
  }
  const openEl = Boolean(anchorEl)

  const onSwitchTheme = (event) => {
    setCurrentTheme(event.target.checked ? darkTheme : theme)
  }

  return (
    <>
      <Stack direction='row' spacing={2} sx={{ position: 'absolute', right: { xs: '5px', sm: '20px' }, top: { xs: '25px', sm: '25px' } }}>
        <IconButton
          aria-label='Téléphone'
          onClick={(ev) =>
            onContactIconClick(
              ev,
              <React.Fragment>
                Tél: <Link href='tel:0495204281'>0495/204.281</Link>
              </React.Fragment>
            )
          }
        >
          <CallTwoToneIcon
            sx={{
              fontSize: { xs: 14, sm: 18 }
            }}
          />
        </IconButton>
        <IconButton
          aria-label='Email'
          onClick={(ev) =>
            onContactIconClick(
              ev,
              <React.Fragment>
                Email: <Link href='mailto:clairdescene@hotmail.com'>clairdescene@hotmail.com</Link>
              </React.Fragment>
            )
          }
        >
          <MailIcon
            sx={{
              fontSize: { xs: 14, sm: 18 }
            }}
          />
        </IconButton>
        <Stack direction='row'>
          <LightModeOutlinedIcon
            fontSize='small'
            sx={{
              position: 'relative',
              top: '10px',
              fontSize: { xs: 14, sm: 18 }
            }}
          />
          <Switch onChange={(event) => onSwitchTheme(event)} color='primary' checked={currentTheme === darkTheme} />
          <DarkModeOutlinedIcon
            fontSize='small'
            sx={{
              position: 'relative',
              top: '10px',
              fontSize: { xs: 14, sm: 18 }
            }}
          />
        </Stack>
      </Stack>

      <Popover
        open={openEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Typography sx={{ p: 2 }}>{anchorText}</Typography>
      </Popover>
    </>
  )
}

HeaderIcons.propTypes = {
  currentTheme: PropTypes.object.isRequired,
  setCurrentTheme: PropTypes.func.isRequired
}
